import { Translation } from '@ps/web-shared-components';
import React from 'react';

import type { Handler } from '../../../../../../../Prompt/Prompt';
import Prompt from '../../../../../../../Prompt/Prompt';

import {
  TXTWCL_Enter_my_address,
  TXTWCL_Okay,
  TXTWCL_Please_enter_your_address_manu_ELL,
  TXTWCL_SorryX_we_couldnXt_accept_that
} from './InvalidAddress.messages.json';

interface Props {
  onClose: Handler;
  onConfirm: Handler;
}

const InvalidAddress: React.FC<Props> = ({ onClose, onConfirm }) => (
  <Prompt
    onClose={onClose}
    onSecondaryButtonClick={onClose}
    onPrimaryButtonClick={onConfirm}
    variant="info"
    title={{
      translation: TXTWCL_SorryX_we_couldnXt_accept_that
    }}
    primaryButton={{
      translation: TXTWCL_Enter_my_address
    }}
    secondaryButton={{
      translation: TXTWCL_Okay
    }}
    alert={<Translation {...TXTWCL_Please_enter_your_address_manu_ELL} />}
  />
);

export default InvalidAddress;
